
import React from 'react';
import { Logout } from 'lib/logout';

export default function LogoutPage() {
    return (
        <Logout toggle={true} />
    );
}
    